/**
 * Human-readable byte size.
 *
 * One decimal place from MB up and none below, so a column of file sizes stays
 * a similar width and stays scannable.
 */
export function formatFileSize(bytes: number | null | undefined): string {
  const b = Number(bytes || 0);
  if (b < 1024) return `${b} B`;
  if (b < 1024 ** 2) return `${Math.round(b / 1024)} KB`;
  if (b < 1024 ** 3) return `${(b / 1024 ** 2).toFixed(1)} MB`;
  if (b < 1024 ** 4) return `${(b / 1024 ** 3).toFixed(1)} GB`;
  return `${(b / 1024 ** 4).toFixed(1)} TB`;
}

/**
 * Short uppercase badge for a file, e.g. `JPG`, `PNG`, `PDF`.
 *
 * Prefers the extension because that is what the user sees in their own file
 * manager, and falls back to the MIME subtype for files that arrive without one.
 */
export function fileTypeLabel(file: File): string {
  const ext = file.name.includes('.') ? file.name.split('.').pop() : '';
  if (ext && ext.length <= 4) return ext.toUpperCase();
  const sub = file.type.split('/')[1];
  return sub ? sub.toUpperCase().slice(0, 4) : 'FILE';
}
